import api from '../../../../api/api';
export const countComments = (items = []) =>
  items.reduce((n, c) => n + (c.isDeleted ? 0 : 1) + countComments(c.replies), 0);
export const flattenReplies = (items = []) =>
  items.flatMap((c) => [c, ...flattenReplies(c.replies)]).sort((a, b) => a.id - b.id);
export const safetyReasons = [
  ['SPAM', '스팸·홍보', 'Spam or promotion'],
  ['HARASSMENT', '괴롭힘·위협', 'Harassment or threats'],
  ['HATE_OR_ABUSE', '혐오·모욕', 'Hate or abusive content'],
  ['SEXUAL_OR_INAPPROPRIATE', '성적·부적절한 내용', 'Sexual or inappropriate content'],
  ['MISINFORMATION', '거짓·오해를 일으키는 정보', 'False or misleading information'],
  ['COPYRIGHT', '저작권·권리 침해', 'Copyright or rights infringement'],
  ['OTHER', '기타', 'Other'],
];
export const reviewDetailApi = {
  async listComments(reviewId, sort, signal) {
    const response = await api.getAuth(`/comments/album_review/${reviewId}?sortBy=${sort}`, {
      signal,
      suppressGlobalError: true,
    });
    return response.data?.data ?? response.data;
  },
  async createComment(reviewId, content, parent) {
    const response = await api.postAuth(
      '/comments',
      {
        articleType: 'ALBUM_REVIEW',
        articleId: Number(reviewId),
        content: content.trim(),
        parentId: parent?.id ?? null,
        mentionedUserId: parent?.user?.id ?? null,
      },
      { suppressGlobalError: true },
    );
    return response.data?.data ?? response.data;
  },
  report: (target, reason, details) =>
    api.postAuth(
      '/safety/reports',
      {
        contentType: target.contentType,
        contentId: target.contentId,
        reason,
        ...(reason === 'OTHER' && { details: details.trim() }),
      },
      { suppressGlobalError: true },
    ),
  block: (target) =>
    api.postAuth(`/safety/blocks/${target.reportedUserId}`, {}, { suppressGlobalError: true }),
};
